import { useTranslation } from 'react-i18next';

import LoadingPage from '@/components/common/LoadingPage';
import SubPageHeader from '@/components/common/SubPageHeader';

import useSelectedParty from '../analysis/hooks/useSelectedParty';

import PolicyItem from './components/PoliciesSection/PolicyItem';
import PolicyPackageItem from './components/PoliciesSection/PolicyPackageItem';
import usePolicies from './queries/hooks/usePolicies';
import usePolicyPackages from './queries/hooks/usePolicyPackages';

export default function PoliciesOverview() {
  const { t } = useTranslation();

  const party = useSelectedParty();

  const { data: policies, isLoading: isPoliciesLoading } = usePolicies(
    party?.id ?? '',
    { activeOnly: true },
    { enabled: Boolean(party?.id) },
  );

  const { data: policyPackages, isLoading: isPolicyPackagesLoading } =
    usePolicyPackages(
      party?.id ?? '',
      { activeOnly: true },
      {
        enabled: Boolean(party?.id),
      },
    );

  const isLoading = isPoliciesLoading || isPolicyPackagesLoading;

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <SubPageHeader>{t('POLICIES_TITLE')}</SubPageHeader>

      <main className="flex-1 overflow-y-auto">
        {isLoading && <LoadingPage />}

        {!isLoading && (
          <div className="flex flex-col gap-1 p-2">
            {policyPackages?.map((policyPackage) => (
              <PolicyPackageItem
                key={policyPackage.id}
                policyPackage={policyPackage}
              />
            ))}

            {policies?.map((policy) => (
              <PolicyItem key={policy.id} policy={policy} />
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
